import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: 'default' | 'search' | 'outline';
  label?: string;
  error?: string;
  helperText?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant = 'default', label, error, helperText, type, ...props }, ref) => {
    const variants = {
      default: 'w-full px-4 py-3 border-2 border-primary-100 rounded-xl focus:border-primary-300 focus:outline-none transition-colors',
      search: 'w-full px-4 py-2 border border-primary-200 rounded-lg focus:border-primary-300 focus:outline-none transition-colors',
      outline: 'w-full px-4 py-3 border-2 border-slate-300 rounded-xl focus:border-primary-300 focus:outline-none transition-colors',
    };

    const inputClasses = `${variants[variant]} ${error ? 'border-red-500 focus:border-red-500' : ''} ${className || ''}`.trim();

    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-slate-700 mb-2">
            {label}
          </label>
        )}
        <input
          type={type}
          className={inputClasses}
          ref={ref}
          {...props}
        />
        {error && (
          <p className="mt-1 text-sm text-red-600">{error}</p>
        )}
        {helperText && !error && (
          <p className="mt-1 text-sm text-slate-500">{helperText}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
